import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import { momentHelper } from '../../report/helpers'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportSummaryDetailInsure extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        ReportStore.loadReportSummaryDetail(this.props.type,this.props.job_type,this.props.id,this.props.year,this.props.month,this.props.day,this.props.viewForm,(result)=>{
            this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
        },()=>{
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        })
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let sum = 0
        data.forEach((item,index)=>{
          let value = (item[field]!==''&&item[field]!==null&&item[field]!==undefined&&!isNaN(item[field])?item[field]:0)
          sum += (value*1)
        })
        return sum
    }
    
    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length===0) {
          return(<tr><td colSpan={9}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.work_date}</td>
              <td className='text-center'>{item.customer_name}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.brand }</td>
              <td className='text-center'>{item.model}</td>
              <td className='text-right'>{this.getNumberFormat(item.quotation_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_amount)}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-analysis'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'100px'}}>หมายเลขใบงาน</td>
                        <td className='text-center' style={{width:'100px'}}>วันที่</td>
                        <td className='text-center' style={{width:'150px'}}>ชื่อลูกค้า</td>
                        <td className='text-center' style={{width:'110px'}}>ทะเบียนรถ</td>
                        <td className='text-center' style={{width:'100px'}}>ยี่ห้อ</td>
                        <td className='text-center' style={{width:'90px'}}>รุ่น</td>
                        <td className='text-center' style={{width:'100px'}}>ราคาเสนอ</td>
                        <td className='text-center' style={{width:'100px'}}>ราคาอนุมัติ</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={7} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('quotation_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_amount'))}</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    getDate() {
        let {day,year,month,isRange,startDate,endDate} = this.props
        if (isRange==='true') {
            return 'ประจำวันที่ '+startDate+' - '+endDate
        } else {
            let text = 'ประจำวันที่ '
            text += day+' '+momentHelper.getMonthText(month)+' '+year
            if (year==='0'||year==='00') {
                text = 'ทั้งหมด'
            } else if (month==='0'||month==='00') {
                text = 'ประจำปี '+year
            } else if (day==='0'||day==='00') {
                text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
            }
          return text
        }  
    }

    renderComponentPage(item,index,length) {
        let {type,job_type} = this.props
        let job_type_text = (job_type==='work'?'ตั้งเบิก':job_type==='received'?'รับเงินแล้ว':job_type==='balance'?'คงเหลือ':'')
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{type==='insurer'?this.props.title+job_type_text+' (รายเดือน)':type==='emp'?'ตารางรายงานสรุปยอดรายได้พนักงานเสนอราคา'+job_type_text+' (รายเดือน)':'ตารางรายงานสรุปยอดรายได้เงินสด'+job_type_text+' (รายเดือน)'}</h2>
                    <div className='text-center'>
                        {this.getDate()}
                    </div>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        let {type,job_type} = this.props
        let job_type_text = (job_type==='work'?'ตั้งเบิก':job_type==='received'?'รับเงินแล้ว':job_type==='balance'?'คงเหลือ':'')
        if (dataList.length===0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={type==='insurer'?this.props.title+job_type_text+' (รายเดือน)':type==='emp'?'ตารางรายงานสรุปยอดรายได้พนักงานเสนอราคา'+job_type_text+' (รายเดือน)':'ตารางรายงานสรุปยอดรายได้เงินสด'+job_type_text+' (รายเดือน)'}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={type==='insurer'?this.props.title+job_type_text+' (รายเดือน)':type==='emp'?'ตารางรายงานสรุปยอดรายได้พนักงานเสนอราคา'+job_type_text+' (รายเดือน)':'ตารางรายงานสรุปยอดรายได้เงินสด'+job_type_text+' (รายเดือน)'}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportSummaryDetailInsure.defaultProps = {
    title:'ตารางรายงานสรุปยอดรายได้ประกัน',
    mode:'',
    workNo:'',
    type:'insurer',
    job_type:'work',
    viewForm:'added_date'
  }
  export default PrintReportSummaryDetailInsure;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportSummaryDetailInsure.js